import { api } from "./api";

// Servicio maestro de ubicaciones (fuente única para toda la plataforma ConstruLink).
// 25 regiones · 196 provincias · 1,893 distritos del INEI.
export const UbicacionesAPI = {
  async totales() {
    const { data } = await api.get("/ubicaciones/totales");
    return data;
  },
  async regiones() {
    const { data } = await api.get("/ubicaciones/regiones");
    return data;
  },
  async provincias(region) {
    if (!region) return [];
    try {
      const { data } = await api.get(`/ubicaciones/regiones/${encodeURIComponent(region)}/provincias`);
      return data;
    } catch {
      return [];
    }
  },
  async distritos(region, provincia) {
    if (!region || !provincia) return [];
    try {
      const { data } = await api.get(
        `/ubicaciones/regiones/${encodeURIComponent(region)}/provincias/${encodeURIComponent(provincia)}/distritos`
      );
      return data;
    } catch {
      return [];
    }
  },
  async validar(region, provincia, distrito) {
    try {
      const { data } = await api.get("/ubicaciones/validar", {
        params: { region, provincia, distrito },
      });
      return { ok: true, data };
    } catch (e) {
      return { ok: false, error: e?.response?.data?.detail || "Ubicación no válida" };
    }
  },
  async buscar(q) {
    const { data } = await api.get("/ubicaciones/buscar", { params: { q, limite: 20 } });
    return data;
  },
};
